export default {
  setCompanies(state, value) {
    state.companies = value
  },
  setCompany(state, value) {
    state.company = value
  },
  setUserCompany(state, value) {
    state.userCompany = value
  },
  clearCompany(state) {
    state.company = {}
  },
  setCompaniesTypes(state, data) {
    state.types = data
  },
}
